import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Layout } from 'antd';
import AppMenu from './AppMenu';
import DOMUtil from "../../../util/DOMUtil";
import { useAppDispatch, useAppSelector } from "../../../store";
import { collapsedNavSelector, offCanvasNavSelector, toggleCollapsedNav, toggleOffCanvasNav } from "../../../store/slice/settings";
const { Sider } = Layout;
const AppSider = () => {
    const sidebarContent = React.useRef(null);
    const collapsedNav = useAppSelector(collapsedNavSelector);
    const offCanvasNav = useAppSelector(offCanvasNavSelector);
    const dispatch = useAppDispatch();
    useEffect(() => {
        window.addEventListener("resize", autoToggleOffCanvasNav);
        return () => {
            window.removeEventListener("resize", autoToggleOffCanvasNav);
        };
    }, []);
    const handleToggleCollapsedNav = (isCollapsedNav) => {
        dispatch(toggleCollapsedNav(isCollapsedNav));
    };
    const handleToggleOffCanvasNav = (isOffCanvasNav) => {
        dispatch(toggleOffCanvasNav(isOffCanvasNav));
    };
    const autoToggleOffCanvasNav = () => {
        const width = DOMUtil.documentWidth();
        const breakpoint = 992;
        if (width >= breakpoint) {
            handleToggleOffCanvasNav(false);
        }
        else {
            handleToggleOffCanvasNav(true);
        }
    };
    const onMenuItemSelected = ( /*menuItem*/) => {
        if (window.innerWidth < 577) {
            handleToggleOffCanvasNav(true);
        }
    };
    const collapsedWidth = offCanvasNav ? 0 : 80;
    return (_jsx(Sider, { collapsible: true, collapsed: collapsedNav || offCanvasNav, collapsedWidth: collapsedWidth, trigger: null, width: 205, className: "app-sidebar sidebar-bg-dark", children: _jsx("div", { className: "sidebar-content", ref: sidebarContent, children: _jsx(AppMenu, { onMenuItemSelected: onMenuItemSelected }) }) }));
};
export default AppSider;
